export interface ApiErrorFormMessage {
  [key: string]: string;
}

export type ApiErrorMessage = ApiErrorFormMessage | string | null | undefined;

export interface ApiError {
  internalErrorCode: number;
  code: number;
  messages: ApiErrorMessage;
  path: string;
}

export type ApiResponse<Response, Default = Record<string, never>> = Response | Default;

export type CommonApiError<T = DefaultResponseError> = {
  data: T;
  status: number;
};

export interface ApiResponseMeta {
  totalItems: number;
  totalPages: number;
  currentPage: number;
  perPage: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
}

export interface DefaultResponse<T> {
  payload: T;
  success: boolean;
}
export interface DefaultResponseError<T = ApiError> {
  error: T;
  success: boolean;
}

export enum EHttpStatusCode {
  OK = 200,
  CREATED = 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  UNPROCESSABLE_CONTENT = 422,
  INTERNAL_SERVER_ERROR = 500,
}
